import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stripe",
  "use": "icon-stripe-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 12\" id=\"icon-stripe\">\n    <path stroke=\"currentColor\" stroke-width=\"2\" d=\"M0 1L16 1M0 6L16 6M0 11L16 11\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol